import React, { useEffect, useState } from 'react';
import axios from 'axios';
import "./instaposts.css";
import { FaInstagram } from "react-icons/fa6";
import SingleBlob from '../blob/singleblob'
import WavesAnimation from '../waves/wavesanimation.jsx';




const InstagramFeed = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const { data } = await axios.get(`https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,permalink&access_token=IGQWRPN0pJUmxORHN0RGVqeVlDeTNVQklXV1Y4dHlMaXo4a3pVMWhHUkJ4OE1yR3R6b3RBaHZAueE9rNWdtXy0yWkdoQk1LTmE0MUpSNWFYNVBsTTNod1VLWlpRbzNQUWN0T1lhVEVySW9aQklXRVlNMEZAjaW1fRlkZD`);
        
        console.log(data)
        setPosts(data.data.slice(0, 5)); // Tomar solo las últimas 5 fotos
      } catch (error) {
        console.error('Error al obtener las fotos de Instagram', error);
      }
    };

    fetchPosts();
  }, []);

  return (
    <section className="instaposts  section" id="instaposts">
             <h2 className="section__title insta__title">
             <i class="uil  uil-instagram insta__icon"></i>
              Follow us on Instagram  
              </h2>
           <span className="section__subtitle">@emanuelpropainting</span>
          <div className='insta__feed'>
        {posts.map((post) => (
          <a href={post.permalink} key={post.id} target="_blank" rel="noopener noreferrer" className='insta__ref'>
            <img src={post.media_url} alt={post.caption} className='insta__images' />
            <div class="overlay__text">Go to post               
              <i class="uil  uil-instagram insta__post__icon"></i>
            </div>
          </a>
        ))}
      </div>
      
    </section>
  );
};

export default InstagramFeed;
